import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { useUserRole } from '@/hooks/useUserRole'
import { LoadingSpinner } from './LoadingSpinner'

export function StaffRoute() {
  const { user, loading: authLoading } = useAuth()
  const { isAdmin, isStaff, loading: roleLoading } = useUserRole()
  const location = useLocation()

  if (authLoading || roleLoading) return <LoadingSpinner />
  if (!user) {
    const returnTo = `${location.pathname}${location.search}${location.hash}`
    return <Navigate to="/sign-in" replace state={{ returnTo }} />
  }
  if (!isAdmin && !isStaff) return <Navigate to="/" replace />

  return <Outlet />
}
